/**
 * IOT-HAL-1: Lightweight ID generator for HAL receipts, events, and records.
 *
 * Uses crypto.randomUUID() (available in all target environments) with an
 * optional short prefix for readability in logs.
 *
 * @param {string} [prefix]
 * @returns {string}
 */
export function createId(prefix) {
  const uuid = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return prefix ? `${prefix}_${uuid}` : uuid;
}
